import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "text-sm text-slate-500"
};
const _hoisted_3 = {
  class: "overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_4 = {
  class: "px-6 py-3 bg-slate-50 border-b border-slate-200 flex items-center gap-3"
};
const _hoisted_5 = {
  class: "p-6"
};
const _hoisted_6 = {
  class: "mb-6"
};
const _hoisted_7 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-3"
};
const _hoisted_8 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_9 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_10 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_11 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_12 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_13 = {
  class: "text-sm font-semibold text-primary-600"
};
const _hoisted_14 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_15 = {
  class: "text-sm text-slate-900"
};
const _hoisted_16 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_17 = {
  class: "text-sm text-slate-900"
};
const _hoisted_18 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors"
};
const _hoisted_19 = {
  class: "text-sm text-slate-900"
};
const _hoisted_20 = {
  class: "bg-slate-50 rounded-xl p-3.5 border border-slate-100 hover:border-slate-200 transition-colors md:col-span-2"
};
const _hoisted_21 = {
  class: "text-sm text-slate-600"
};
const _hoisted_22 = {
  class: "mb-6"
};
const _hoisted_23 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
};
const _hoisted_24 = {
  class: "bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl p-4"
};
const _hoisted_25 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_26 = {
  class: "flex items-center gap-2"
};
const _hoisted_27 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_28 = {
  class: "text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded"
};
const _hoisted_29 = {
  class: "flex items-center gap-1.5 text-sm text-slate-600"
};
const _hoisted_30 = {
  key: 0,
  class: "flex items-start gap-1.5 text-xs text-slate-500"
};
const _hoisted_31 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_32 = {
  class: "bg-gradient-to-br from-green-50 to-white border border-green-100 rounded-xl p-4"
};
const _hoisted_33 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_34 = {
  class: "flex items-center gap-2"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 1,
  class: "w-8 h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white text-sm font-medium"
};
const _hoisted_37 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_38 = {
  class: "flex items-center gap-1.5 text-sm text-slate-600"
};
const _hoisted_39 = {
  key: 0,
  class: "flex items-center gap-1.5 text-xs text-slate-500"
};
const _hoisted_40 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_41 = {
  class: "bg-gradient-to-br from-purple-50 to-white border border-purple-100 rounded-xl p-4"
};
const _hoisted_42 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_43 = {
  class: "space-y-3"
};
const _hoisted_44 = {
  class: "flex justify-end gap-2"
};
const _hoisted_45 = ["disabled"];
const _hoisted_46 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_47 = {
  class: "flex items-center gap-2"
};
const _hoisted_48 = ["src"];
const _hoisted_49 = {
  key: 1,
  class: "w-8 h-8 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center text-white text-sm font-medium"
};
const _hoisted_50 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_51 = {
  class: "flex items-center gap-1.5 text-sm text-slate-600"
};
const _hoisted_52 = {
  key: 0,
  class: "flex items-center gap-1.5 text-xs text-slate-500"
};
const _hoisted_53 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_54 = {
  key: 0,
  class: "mb-6"
};
const _hoisted_55 = {
  class: "bg-slate-50 rounded-lg p-3 text-sm text-slate-600"
};
const _hoisted_56 = {
  key: 1,
  class: "mb-6"
};
const _hoisted_57 = {
  class: "bg-slate-50 rounded-lg p-3 text-sm text-slate-600"
};
const _hoisted_58 = {
  key: 2,
  class: "mb-6"
};
const _hoisted_59 = {
  class: "bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-700"
};
const _hoisted_60 = {
  key: 3,
  class: "mb-6"
};
const _hoisted_61 = {
  class: "flex items-center gap-2 mb-3"
};
const _hoisted_62 = {
  class: "px-1.5 py-0.5 bg-slate-100 text-slate-600 text-xs font-medium rounded"
};
const _hoisted_63 = {
  class: "space-y-2"
};
const _hoisted_64 = {
  class: "shrink-0"
};
const _hoisted_65 = {
  key: 0,
  class: "w-4 h-4 text-amber-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_66 = {
  key: 1,
  class: "w-4 h-4 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_67 = {
  key: 2,
  class: "w-4 h-4 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_68 = {
  class: "flex-1 min-w-0"
};
const _hoisted_69 = {
  class: "flex items-center gap-2 mb-1"
};
const _hoisted_70 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_71 = {
  class: "shrink-0 text-xs text-slate-500"
};
const _hoisted_72 = {
  key: 0,
  class: "shrink-0 text-xs px-1.5 py-0.5 bg-rose-100 text-rose-700 rounded"
};
const _hoisted_73 = {
  class: "flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500"
};
const _hoisted_74 = {
  key: 0
};
const _hoisted_75 = {
  key: 0,
  class: "mt-1.5 text-xs text-amber-700 bg-amber-50 px-2 py-1 rounded"
};
const _hoisted_76 = {
  class: "shrink-0 flex items-center gap-1.5"
};
const _hoisted_77 = ["onClick"];
const _hoisted_78 = ["onClick", "title"];
const _hoisted_79 = ["onClick"];
const _hoisted_80 = ["onClick"];
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
  key: 4
};
const _hoisted_83 = {
  class: "grid grid-cols-1 lg:grid-cols-2 gap-4"
};
const _hoisted_84 = {
  class: "flex items-start justify-between mb-3"
};
const _hoisted_85 = {
  class: "flex items-center gap-2"
};
const _hoisted_86 = {
  key: 0,
  class: "px-2 py-0.5 text-xs rounded-full bg-rose-100 text-rose-700"
};
const _hoisted_87 = {
  class: "text-xs text-slate-400"
};
const _hoisted_88 = {
  class: "text-right"
};
const _hoisted_89 = {
  class: "text-lg font-bold text-slate-900"
};
const _hoisted_90 = {
  class: "mb-3"
};
const _hoisted_91 = {
  class: "flex items-center justify-between text-xs mb-1.5"
};
const _hoisted_92 = {
  class: "font-medium text-slate-700"
};
const _hoisted_93 = {
  class: "h-2 bg-slate-100 rounded-full overflow-hidden"
};
const _hoisted_94 = {
  class: "flex justify-between text-xs text-slate-500 mt-1"
};
const _hoisted_95 = {
  class: "grid grid-cols-2 gap-2 mb-3 text-xs"
};
const _hoisted_96 = {
  class: "bg-white rounded-lg p-2 border border-slate-100"
};
const _hoisted_97 = {
  class: "font-medium text-slate-700"
};
const _hoisted_98 = {
  class: "bg-white rounded-lg p-2 border border-slate-100"
};
const _hoisted_99 = {
  class: "font-medium text-slate-700"
};
const _hoisted_100 = {
  class: "flex items-center justify-between"
};
const _hoisted_101 = {
  class: "text-xs text-slate-400"
};
const _hoisted_102 = {
  class: "flex items-center gap-2"
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = ["disabled"];
const _hoisted_105 = {
  key: 1,
  class: "px-2 py-1 text-xs bg-emerald-100 text-emerald-700 rounded-lg font-medium flex items-center gap-1"
};
const _hoisted_106 = ["onClick"];
const _hoisted_107 = {
  key: 5,
  class: "mb-6"
};
const _hoisted_108 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_109 = {
  class: "absolute -top-2 -left-2 w-7 h-7 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center shadow-lg"
};
const _hoisted_110 = {
  class: "text-xs font-bold text-white"
};
const _hoisted_111 = {
  class: "flex items-start justify-between mb-3"
};
const _hoisted_112 = {
  class: "flex-1"
};
const _hoisted_113 = {
  class: "flex items-center gap-2 mb-1"
};
const _hoisted_114 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_115 = {
  key: 0,
  class: "text-xs text-slate-500"
};
const _hoisted_116 = ["onClick"];
const _hoisted_117 = {
  class: "mb-3"
};
const _hoisted_118 = {
  class: "flex items-center justify-between text-xs text-slate-600 mb-1"
};
const _hoisted_119 = {
  class: "font-semibold"
};
const _hoisted_120 = {
  class: "w-full bg-slate-200 rounded-full h-2 overflow-hidden"
};
const _hoisted_121 = {
  key: 0,
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_122 = {
  class: "w-6 h-6 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center text-white text-xs font-medium"
};
const _hoisted_123 = {
  class: "text-sm text-slate-700"
};
const _hoisted_124 = {
  class: "flex flex-wrap gap-3 text-xs text-slate-500"
};
const _hoisted_125 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_126 = {
  key: 1,
  class: "flex items-center gap-1"
};
const _hoisted_127 = {
  key: 1,
  class: "mt-2 pt-2 border-t border-slate-200"
};
const _hoisted_128 = {
  class: "text-xs text-slate-600 line-clamp-2"
};
const _hoisted_129 = {
  class: "mt-6 mb-6"
};
const _hoisted_130 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_131 = ["onClick"];
const _hoisted_132 = {
  class: "flex items-center gap-2"
};
const _hoisted_133 = {
  class: "inline-flex items-center gap-1 text-xs text-slate-400"
};
const _hoisted_134 = {
  class: "px-4 py-2.5 text-xs text-slate-400 flex flex-wrap items-center gap-x-4 gap-y-1"
};
const _hoisted_135 = {
  key: 0,
  class: "inline-flex items-center gap-1"
};
const _hoisted_136 = {
  key: 1,
  class: "inline-flex items-center gap-1"
};
const _hoisted_137 = {
  key: 0
};
const _hoisted_138 = {
  class: "bg-slate-50 border-t border-slate-100"
};
const _hoisted_139 = {
  class: "px-4 py-3"
};
const _hoisted_140 = {
  class: "space-y-3"
};
const _hoisted_141 = {
  class: "flex-1 min-w-0"
};
const _hoisted_142 = {
  class: "text-xs"
};
const _hoisted_143 = {
  class: "text-slate-700"
};
const _hoisted_144 = {
  class: "text-slate-400 ml-1.5"
};
const _hoisted_145 = {
  class: "text-sm text-slate-600 mt-1"
};
const _hoisted_146 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_147 = ["onClick"];
const _hoisted_148 = {
  class: "px-4 py-2.5 border-t border-slate-100 flex items-center gap-2"
};
const _hoisted_149 = ["onClick"];
const _hoisted_150 = ["onClick"];
const _hoisted_151 = ["onClick"];
const _hoisted_152 = ["onClick"];
const _hoisted_153 = ["onClick"];
const _hoisted_154 = {
  key: 1,
  class: "data-table-empty is-compact"
};
const _hoisted_155 = {
  class: "mb-6"
};
const _hoisted_156 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_157 = {
  class: "flex items-center gap-2"
};
const _hoisted_158 = {
  class: "px-1.5 py-0.5 bg-slate-100 text-slate-600 text-xs font-medium rounded"
};
const _hoisted_159 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_160 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_161 = {
  class: "min-w-0 flex-1"
};
const _hoisted_162 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_163 = {
  class: "text-sm font-semibold text-slate-900 truncate"
};
const _hoisted_164 = {
  key: 0,
  class: "shrink-0 px-1.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
};
const _hoisted_165 = {
  key: 0,
  class: "mt-1 text-sm text-slate-600 line-clamp-2"
};
const _hoisted_166 = {
  class: "mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500"
};
const _hoisted_167 = {
  key: 0
};
const _hoisted_168 = {
  class: "mt-2 flex flex-wrap items-center gap-1.5"
};
const _hoisted_169 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_170 = {
  class: "shrink-0 flex items-center gap-1"
};
const _hoisted_171 = ["onClick"];
const _hoisted_172 = ["onClick"];
const _hoisted_173 = ["onClick"];
const _hoisted_174 = ["onClick"];
const _hoisted_175 = {
  key: 1,
  class: "data-table-empty is-compact"
};
const _hoisted_176 = {
  class: "px-6 py-4 border-t border-slate-200"
};
const _hoisted_177 = {
  class: "flex items-center justify-end"
};
const _hoisted_178 = {
  class: "flex items-center gap-3"
};
const _hoisted_179 = {
  class: "space-y-4"
};
const _hoisted_180 = {
  class: "rounded-lg bg-slate-50 p-4 text-sm text-slate-600"
};
const _hoisted_181 = {
  class: "mt-1"
};
const _hoisted_182 = {
  class: "flex flex-col gap-3 md:flex-row"
};
const _hoisted_183 = {
  class: "max-h-[420px] overflow-y-auto rounded-lg border border-slate-200"
};
const _hoisted_184 = {
  class: "min-w-full text-sm"
};
const _hoisted_185 = {
  class: "px-4 py-3"
};
const _hoisted_186 = {
  class: "px-4 py-3 text-slate-900"
};
const _hoisted_187 = {
  class: "px-4 py-3 text-slate-600"
};
const _hoisted_188 = {
  class: "px-4 py-3 text-slate-600"
};
const _hoisted_189 = {
  class: "px-4 py-3"
};
const _hoisted_190 = {
  class: "px-4 py-3 text-slate-600"
};
const _hoisted_191 = {
  key: 0
};
const _hoisted_192 = {
  class: "flex justify-end gap-3"
};
const _hoisted_193 = ["disabled"];
const _hoisted_194 = {
  class: "space-y-4"
};
const _hoisted_195 = {
  class: "rounded-lg bg-slate-50 p-4 text-sm text-slate-600"
};
const _hoisted_196 = {
  class: "flex justify-end gap-3"
};
const _hoisted_197 = ["disabled"];
const _hoisted_198 = {
  class: "space-y-4"
};
const _hoisted_199 = {
  class: "rounded-lg bg-slate-50 p-4 text-sm text-slate-600"
};
const _hoisted_200 = {
  class: "flex justify-end gap-3"
};
const _hoisted_201 = ["disabled"];
const _hoisted_202 = {
  class: "space-y-4"
};
const _hoisted_203 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_204 = {
  class: "rounded-lg border border-slate-200 p-3"
};
const _hoisted_205 = {
  class: "flex items-center gap-2 text-sm text-slate-700 cursor-pointer"
};
const _hoisted_206 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-3"
};
const _hoisted_207 = {
  class: "mt-3 flex items-center gap-2 text-sm text-slate-600 cursor-pointer"
};
const _hoisted_208 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_209 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_210 = ["onClick"];
const _hoisted_211 = {
  key: 0,
  class: "text-slate-400 ml-1"
};
const _hoisted_212 = {
  class: "flex justify-end gap-3"
};
const _hoisted_213 = ["disabled"];
const _hoisted_214 = {
  class: "space-y-4"
};
const _hoisted_215 = {
  key: 0
};
const _hoisted_216 = {
  class: "flex items-center gap-3"
};
const _hoisted_217 = {
  class: "flex items-center gap-1.5 text-sm text-slate-600 cursor-pointer"
};
const _hoisted_218 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_219 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_220 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_221 = ["onClick"];
const _hoisted_222 = {
  key: 0,
  class: "text-slate-400 ml-1"
};
const _hoisted_223 = {
  class: "flex justify-end gap-3"
};
const _hoisted_224 = ["disabled"];
const _hoisted_225 = {
  class: "space-y-4"
};
const _hoisted_226 = {
  class: "flex items-center gap-3"
};
const _hoisted_227 = {
  class: "flex items-center gap-1.5 text-sm text-slate-600 cursor-pointer"
};
const _hoisted_228 = {
  key: 0,
  class: "space-y-4"
};
const _hoisted_229 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_230 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_231 = ["onClick"];
const _hoisted_232 = {
  key: 0,
  class: "text-slate-400 ml-1"
};
const _hoisted_233 = {
  class: "flex justify-end gap-3"
};
const _hoisted_234 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { bindOrderMaterial, changeOrderExecutor, createOrderAnnotation, createOrderReminder, createServiceStep, deleteOrderReminder, deleteServiceStep, disableOrderReminder, enableOrderReminder, getOrderTracking, reviewOrderMaterialBinding, unbindOrderMaterial, updateOrderReminder, updateServiceStep, updateStepStatus } from '@/api/order';
import { getCustomerMaterialDetailById, listCustomerMaterialInstances, updateCustomerMaterialVisibility } from '@/api/customer';
import { createOrGetCashierByBilling } from '@/api/cashier';
import { getBillingRefundView } from '@/api/refund';
import { formatDateTimeText } from '@/utils/dateFormat';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import RefundApplyModal from '@/components/RefundApplyModal.vue';
import OrderMaterialDetailDialog from './OrderMaterialDetailDialog.vue';

// eslint-disable-next-line no-unused-vars

export default {
  __name: 'OrderDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default: () => null
    },
    traceList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'close', 'receive', 'editTask', 'edit', 'approval-detail', 'executorChanged', 'refreshDetail'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 更换执行人相关状态
    const showExecutorPopover = ref(false);
    const newExecutorId = ref(null);
    const executorSubmitting = ref(false);
    const bindingDialogVisible = ref(false);
    const bindingDialogLoading = ref(false);
    const bindingSubmitting = ref(false);
    const bindingTargetMaterial = ref(null);
    const candidateKeyword = ref('');
    const candidateVisibilityFilter = ref('');
    const materialCandidates = ref([]);
    const selectedCandidateId = ref(null);
    const unbindDialogVisible = ref(false);
    const unbindSubmitting = ref(false);
    const unbindReason = ref('');
    const unbindTargetMaterial = ref(null);
    const reviewDialogVisible = ref(false);
    const reviewSubmitting = ref(false);
    const reviewForm = reactive({
      approved: true,
      reviewRemark: ''
    });
    const reviewTargetMaterial = ref(null);
    const materialDetailDialogVisible = ref(false);
    const selectedMaterialDetailId = ref(null);
    const creatingCashierBillingId = ref(null);

    // ── 服务跟踪状态 ──
    const steps = ref([]);
    const expandedStepIds = ref(new Set());
    const trackingLoading = ref(false);

    // 头像颜色（根据名字哈希取色）
    const avatarColors = ['#1890ff', '#52c41a', '#fa8c16', '#722ed1', '#eb2f96', '#faad14', '#13c2c2'];
    const getAvatarColor = name => {
      if (!name) return avatarColors[0];
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      return avatarColors[Math.abs(hash) % avatarColors.length];
    };

    // 步骤弹窗状态
    const stepDialogVisible = ref(false);
    const stepSubmitting = ref(false);
    const stepForm = reactive({
      id: null,
      name: '',
      content: '',
      status: 0,
      enableReminder: false,
      nextRemindAt: '',
      remindUserIds: []
    });
    const isEditingStep = ref(false);

    // 批注弹窗状态
    const annotationDialogVisible = ref(false);
    const annotationSubmitting = ref(false);
    const annotationTargetStepId = ref(null);
    const annotationForm = reactive({
      content: '',
      enableReminder: false,
      nextRemindAt: '',
      remindUserIds: []
    });
    const reminderDialogVisible = ref(false);
    const reminderSubmitting = ref(false);
    const isEditingReminder = ref(false);
    const reminderForm = reactive({
      id: null,
      title: '',
      content: '',
      firstSendTime: '',
      repeatEnabled: false,
      repeatIntervalMinutes: 1440,
      maxReminderCount: 3,
      deadlineTime: '',
      autoCloseAtDeadline: false,
      receiverUserIds: []
    });
    const materialStatusMap = {
      UNBOUND: {
        text: '未绑定',
        class: 'bg-slate-100 text-slate-600'
      },
      PENDING: {
        text: '待审核',
        class: 'bg-amber-100 text-amber-700'
      },
      APPROVED: {
        text: '已绑定',
        class: 'bg-green-100 text-green-700'
      },
      REJECTED: {
        text: '已驳回',
        class: 'bg-red-100 text-red-700'
      },
      INVALID: {
        text: '已解绑',
        class: 'bg-slate-200 text-slate-500'
      }
    };
    const materialBindSourceMap = {
      APP: '客户APP绑定',
      ADMIN: '平台绑定',
      SYSTEM: '系统绑定'
    };
    const materialList = computed(() => {
      return (props.orderDetail?.materials || []).map(item => {
        const currentBinding = item.currentBinding || {};
        const currentMaterialName = item.currentMaterialName || currentBinding.userMaterialName || '-';
        const visibleToCustomer = item.currentMaterialVisibleToCustomer;
        return {
          ...item,
          currentBinding,
          isBound: !!item.currentBindingId,
          currentMaterialName,
          bindingStatusText: materialStatusMap[item.bindingStatus]?.text || (item.currentBindingId ? '已绑定' : '未绑定'),
          bindingStatusClass: materialStatusMap[item.bindingStatus]?.class || 'bg-slate-100 text-slate-600',
          bindingSourceText: materialBindSourceMap[currentBinding.bindSource] || '-',
          currentMaterialVisibleToCustomer: visibleToCustomer,
          visibilityText: visibleToCustomer === true ? '对客户可见' : visibleToCustomer === false ? '对客户隐藏' : '-',
          needReview: currentBinding.bindSource === 'APP' && item.bindingStatus === 'PENDING',
          submitTime: currentBinding.submitTime || currentBinding.bindTime || currentBinding.createTime || null,
          reviewRemark: currentBinding.reviewRemark || ''
        };
      });
    });
    const filteredMaterialCandidates = computed(() => {
      const keyword = candidateKeyword.value.trim().toLowerCase();
      return materialCandidates.value.filter(item => {
        if (candidateVisibilityFilter.value === 'visible' && item.visibleToCustomer !== true) {
          return false;
        }
        if (candidateVisibilityFilter.value === 'hidden' && item.visibleToCustomer !== false) {
          return false;
        }
        if (!keyword) {
          return true;
        }
        return [item.name, item.definitionName, item.definitionCode].some(value => String(value || '').toLowerCase().includes(keyword));
      });
    });
    const orderReminderList = computed(() => props.orderDetail?.reminders || []);
    const reminderDialogTitle = computed(() => isEditingReminder.value ? '编辑订单提醒' : '添加订单提醒');
    const orderRelatedReminderUsers = computed(() => {
      const map = new Map();
      const addUser = (user, role) => {
        const id = user?.id;
        if (!id) return;
        if (!map.has(id)) {
          map.set(id, {
            id,
            displayName: user.displayName || user.username || `用户${id}`,
            username: user.username,
            phone: user.phone,
            roles: []
          });
        }
        const current = map.get(id);
        if (!current.roles.includes(role)) {
          current.roles.push(role);
        }
      };
      addUser(props.orderDetail?.createUser, '创建人');
      addUser(props.orderDetail?.executor, '执行人');
      return Array.from(map.values());
    });

    // 是否可以更换执行人：仅待确认(0)、执行中(1)、已驳回(4)状态可更换
    const canChangeExecutor = computed(() => {
      const status = props.orderDetail?.status;
      return status === 0 || status === 1 || status === 4;
    });
    const handleClose = () => {
      materialDetailDialogVisible.value = false;
      selectedMaterialDetailId.value = null;
      emit('update:visible', false);
      emit('close');
    };
    const handleReceive = billing => {
      emit('receive', billing);
    };
    const openCashierPage = async billing => {
      if (!billing?.id) return;
      creatingCashierBillingId.value = billing.id;
      try {
        const created = await createOrGetCashierByBilling(Number(billing.id));
        const cashierNo = created?.cashierNo || '';
        if (!cashierNo) {
          ElMessage.error('收银台创建失败，请稍后重试');
          return;
        }
        billing.cashierNo = cashierNo;
        const targetUrl = `${window.location.origin}/cashier/${cashierNo}`;
        window.open(targetUrl, '_blank');
      } catch (error) {
        ElMessage.error(error?.message || '创建收银台失败，请稍后重试');
      } finally {
        creatingCashierBillingId.value = null;
      }
    };
    const handleCashierAction = (cmd, billing) => {
      if (cmd === 'open') {
        openCashierPage(billing);
      } else if (cmd === 'copy') {
        copyCashierLink(billing);
      }
    };
    const copyCashierLink = async billing => {
      if (!billing?.id) return;
      creatingCashierBillingId.value = billing.id;
      try {
        const created = await createOrGetCashierByBilling(Number(billing.id));
        const cashierNo = created?.cashierNo || '';
        if (!cashierNo) {
          ElMessage.error('收银台创建失败，请稍后重试');
          return;
        }
        const targetUrl = `${window.location.origin}/cashier/${cashierNo}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(targetUrl);
        } else {
          // 降级方案
          const textarea = document.createElement('textarea');
          textarea.value = targetUrl;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        ElMessage.success('收银台链接已复制到剪贴板');
      } catch (error) {
        ElMessage.error(error?.message || '复制失败，请稍后重试');
      } finally {
        creatingCashierBillingId.value = null;
      }
    };
    const handleEditTask = task => {
      emit('editTask', task);
    };

    // 编辑订单
    const handleEdit = () => {
      emit('edit', props.orderDetail);
    };

    // 执行人相关方法
    const openExecutorPopover = () => {
      showExecutorPopover.value = true;
      newExecutorId.value = null;
    };
    const closeExecutorPopover = () => {
      showExecutorPopover.value = false;
      newExecutorId.value = null;
    };
    const handleChangeExecutor = async () => {
      if (!newExecutorId.value) {
        ElMessage.warning('请选择新执行人');
        return;
      }
      executorSubmitting.value = true;
      try {
        await changeOrderExecutor({
          orderId: props.orderDetail.id,
          executorId: newExecutorId.value
        });
        ElMessage.success('执行人更换成功');
        closeExecutorPopover();
        emit('executorChanged');
      } catch (error) {
        ElMessage.error(error.message || '更换执行人失败');
      } finally {
        executorSubmitting.value = false;
      }
    };
    const currentCustomerId = computed(() => props.orderDetail?.customer?.id || props.orderDetail?.customerId || null);
    const notifyRefreshDetail = () => {
      emit('refreshDetail');
    };
    const reminderStatusText = status => {
      const map = {
        ENABLED: '已启用',
        DISABLED: '已停用',
        DELETED: '已删除'
      };
      return map[status] || '未知';
    };
    const reminderStatusClass = status => {
      const map = {
        ENABLED: 'bg-green-100 text-green-700',
        DISABLED: 'bg-slate-100 text-slate-600',
        DELETED: 'bg-red-100 text-red-700'
      };
      return map[status] || 'bg-slate-100 text-slate-600';
    };
    const reminderRepeatText = reminder => {
      if (!reminder.repeatEnabled) {
        return '不重复';
      }
      const interval = reminder.repeatIntervalMinutes || 0;
      const count = reminder.maxReminderCount || 0;
      return `每 ${interval} 分钟，最多 ${count} 次`;
    };
    const resetReminderForm = () => {
      reminderForm.id = null;
      reminderForm.title = '';
      reminderForm.content = '';
      reminderForm.firstSendTime = '';
      reminderForm.repeatEnabled = false;
      reminderForm.repeatIntervalMinutes = 1440;
      reminderForm.maxReminderCount = 3;
      reminderForm.deadlineTime = '';
      reminderForm.autoCloseAtDeadline = false;
      reminderForm.receiverUserIds = [];
    };
    const openAddReminderDialog = () => {
      isEditingReminder.value = false;
      resetReminderForm();
      reminderDialogVisible.value = true;
    };
    const openEditReminderDialog = reminder => {
      isEditingReminder.value = true;
      reminderForm.id = reminder.id;
      reminderForm.title = reminder.title || '';
      reminderForm.content = reminder.content || '';
      reminderForm.firstSendTime = toDatetimeLocal(reminder.firstSendTime);
      reminderForm.repeatEnabled = !!reminder.repeatEnabled;
      reminderForm.repeatIntervalMinutes = reminder.repeatIntervalMinutes || 1440;
      reminderForm.maxReminderCount = reminder.maxReminderCount || 3;
      reminderForm.deadlineTime = toDatetimeLocal(reminder.deadlineTime);
      reminderForm.autoCloseAtDeadline = !!reminder.autoCloseAtDeadline;
      reminderForm.receiverUserIds = (reminder.receivers || []).map(item => item.userId).filter(Boolean);
      reminderDialogVisible.value = true;
    };
    const closeReminderDialog = () => {
      reminderDialogVisible.value = false;
      reminderSubmitting.value = false;
    };
    const isReminderReceiverSelected = userId => reminderForm.receiverUserIds.includes(userId);
    const toggleReminderReceiver = userId => {
      if (!userId) return;
      if (isReminderReceiverSelected(userId)) {
        reminderForm.receiverUserIds = reminderForm.receiverUserIds.filter(id => id !== userId);
      } else {
        reminderForm.receiverUserIds = [...reminderForm.receiverUserIds, userId];
      }
    };
    const toggleStepRemindUser = userId => {
      if (!userId) return;
      const idx = stepForm.remindUserIds.indexOf(userId);
      if (idx >= 0) {
        stepForm.remindUserIds.splice(idx, 1);
      } else {
        stepForm.remindUserIds.push(userId);
      }
    };
    const toggleAnnotationRemindUser = userId => {
      if (!userId) return;
      const idx = annotationForm.remindUserIds.indexOf(userId);
      if (idx >= 0) {
        annotationForm.remindUserIds.splice(idx, 1);
      } else {
        annotationForm.remindUserIds.push(userId);
      }
    };
    const buildReminderPayload = () => {
      const repeatEnabled = !!reminderForm.repeatEnabled;
      return {
        id: reminderForm.id || undefined,
        title: reminderForm.title.trim(),
        content: reminderForm.content.trim() || undefined,
        firstSendTime: toApiDatetime(reminderForm.firstSendTime),
        repeatEnabled,
        repeatIntervalMinutes: repeatEnabled ? Number(reminderForm.repeatIntervalMinutes || 0) : 0,
        maxReminderCount: repeatEnabled ? Number(reminderForm.maxReminderCount || 0) : 0,
        deadlineTime: toApiDatetime(reminderForm.deadlineTime),
        autoCloseAtDeadline: !!reminderForm.autoCloseAtDeadline,
        receiverUserIds: Array.from(new Set(reminderForm.receiverUserIds.filter(Boolean)))
      };
    };
    const validateReminderForm = () => {
      if (!reminderForm.title.trim()) {
        ElMessage.warning('请输入提醒标题');
        return false;
      }
      if (!reminderForm.firstSendTime) {
        ElMessage.warning('请选择首次提醒时间');
        return false;
      }
      if (reminderForm.receiverUserIds.length === 0) {
        ElMessage.warning('请选择提醒接收人');
        return false;
      }
      if (reminderForm.repeatEnabled) {
        if (Number(reminderForm.repeatIntervalMinutes || 0) <= 0) {
          ElMessage.warning('重复间隔必须大于0');
          return false;
        }
        if (Number(reminderForm.maxReminderCount || 0) <= 0) {
          ElMessage.warning('最大提醒次数必须大于0');
          return false;
        }
      }
      if (reminderForm.autoCloseAtDeadline && !reminderForm.deadlineTime) {
        ElMessage.warning('自动关闭提醒需要填写截止时间');
        return false;
      }
      if (reminderForm.deadlineTime && reminderForm.deadlineTime < reminderForm.firstSendTime) {
        ElMessage.warning('截止时间不能早于首次提醒时间');
        return false;
      }
      return true;
    };
    const handleSubmitReminder = async () => {
      if (!validateReminderForm()) return;
      reminderSubmitting.value = true;
      try {
        const payload = buildReminderPayload();
        if (isEditingReminder.value) {
          await updateOrderReminder(props.orderDetail.id, reminderForm.id, payload);
          ElMessage.success('订单提醒已更新');
        } else {
          await createOrderReminder(props.orderDetail.id, payload);
          ElMessage.success('订单提醒已添加');
        }
        closeReminderDialog();
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '保存订单提醒失败');
      } finally {
        reminderSubmitting.value = false;
      }
    };
    const handleToggleReminder = async reminder => {
      try {
        if (reminder.status === 'ENABLED') {
          await disableOrderReminder(props.orderDetail.id, reminder.id);
          ElMessage.success('订单提醒已停用');
        } else {
          await enableOrderReminder(props.orderDetail.id, reminder.id);
          ElMessage.success('订单提醒已启用');
        }
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '更新提醒状态失败');
      }
    };
    const handleDeleteReminder = async reminder => {
      try {
        await ElMessageBox.confirm(`确认删除提醒“${reminder.title || ''}”？`, '删除确认', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        });
      } catch {
        return;
      }
      try {
        await deleteOrderReminder(props.orderDetail.id, reminder.id);
        ElMessage.success('订单提醒已删除');
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '删除订单提醒失败');
      }
    };
    const getCandidateVisibilityText = visibleToCustomer => {
      return visibleToCustomer ? '对客户可见' : '对客户隐藏';
    };
    const openMaterialDetailDialog = material => {
      if (!material?.currentUserMaterialId) {
        ElMessage.warning('当前未绑定资料');
        return;
      }
      selectedMaterialDetailId.value = material.currentUserMaterialId;
      materialDetailDialogVisible.value = true;
    };
    const openBindingDialog = async material => {
      if (!currentCustomerId.value) {
        ElMessage.warning('订单未关联客户，无法选择资料');
        return;
      }
      bindingTargetMaterial.value = material;
      selectedCandidateId.value = material.currentUserMaterialId || null;
      candidateKeyword.value = '';
      candidateVisibilityFilter.value = '';
      materialCandidates.value = [];
      bindingDialogVisible.value = true;
      bindingDialogLoading.value = true;
      try {
        const result = await listCustomerMaterialInstances(currentCustomerId.value, {
          definitionCode: material.definitionCode
        });
        const list = Array.isArray(result) ? result : [];
        materialCandidates.value = list.map(item => ({
          ...item,
          isCurrentBinding: item.id === material.currentUserMaterialId
        }));
      } catch (error) {
        ElMessage.error(error?.message || '获取资料候选列表失败');
      } finally {
        bindingDialogLoading.value = false;
      }
    };
    const closeBindingDialog = () => {
      bindingDialogVisible.value = false;
      bindingTargetMaterial.value = null;
      selectedCandidateId.value = null;
      candidateKeyword.value = '';
      candidateVisibilityFilter.value = '';
      materialCandidates.value = [];
    };
    const ensureCandidateVisibleToCustomer = async candidate => {
      if (candidate.visibleToCustomer !== false) {
        return;
      }
      const detail = await getCustomerMaterialDetailById(candidate.id);
      await updateCustomerMaterialVisibility({
        userMaterialId: detail.id,
        customerId: detail.customerId,
        definitionCode: detail.definitionCode,
        name: detail.name,
        formData: detail.formData,
        expireDate: detail.expireDate,
        visibleToCustomer: true
      });
    };
    const handleConfirmBinding = async () => {
      const targetMaterial = bindingTargetMaterial.value;
      const selectedCandidate = filteredMaterialCandidates.value.find(item => item.id === selectedCandidateId.value);
      if (!targetMaterial || !selectedCandidate) {
        ElMessage.warning('请选择要绑定的资料');
        return;
      }
      try {
        if (selectedCandidate.visibleToCustomer === false) {
          await ElMessageBox.confirm('该资料当前对客户不可见，绑定后将自动改为对客户可见，是否继续？', '绑定确认', {
            type: 'warning',
            confirmButtonText: '继续绑定',
            cancelButtonText: '取消'
          });
        }
      } catch {
        return;
      }
      bindingSubmitting.value = true;
      try {
        await ensureCandidateVisibleToCustomer(selectedCandidate);
        await bindOrderMaterial(targetMaterial.id, {
          orderId: props.orderDetail.id,
          userMaterialId: selectedCandidate.id,
          bindSource: 'ADMIN'
        });
        ElMessage.success(targetMaterial.isBound ? '资料更换成功' : '资料绑定成功');
        closeBindingDialog();
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '资料绑定失败');
      } finally {
        bindingSubmitting.value = false;
      }
    };
    const openUnbindDialog = material => {
      unbindTargetMaterial.value = material;
      unbindReason.value = '';
      unbindDialogVisible.value = true;
    };
    const closeUnbindDialog = () => {
      unbindDialogVisible.value = false;
      unbindReason.value = '';
      unbindTargetMaterial.value = null;
    };
    const handleConfirmUnbind = async () => {
      if (!unbindTargetMaterial.value?.currentBindingId) {
        return;
      }
      unbindSubmitting.value = true;
      try {
        await unbindOrderMaterial(unbindTargetMaterial.value.currentBindingId, unbindReason.value.trim());
        ElMessage.success('资料解绑成功');
        closeUnbindDialog();
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '资料解绑失败');
      } finally {
        unbindSubmitting.value = false;
      }
    };
    const openReviewDialog = (material, approved) => {
      reviewTargetMaterial.value = material;
      reviewForm.approved = approved;
      reviewForm.reviewRemark = '';
      reviewDialogVisible.value = true;
    };
    const closeReviewDialog = () => {
      reviewDialogVisible.value = false;
      reviewForm.approved = true;
      reviewForm.reviewRemark = '';
      reviewTargetMaterial.value = null;
    };
    const handleSubmitReview = async () => {
      if (!reviewTargetMaterial.value?.currentBindingId) {
        return;
      }
      if (!reviewForm.approved && !reviewForm.reviewRemark.trim()) {
        ElMessage.warning('请填写驳回原因');
        return;
      }
      reviewSubmitting.value = true;
      try {
        await reviewOrderMaterialBinding(reviewTargetMaterial.value.currentBindingId, {
          approved: reviewForm.approved,
          reviewRemark: reviewForm.reviewRemark.trim() || undefined
        });
        ElMessage.success(reviewForm.approved ? '审核通过' : '已驳回');
        closeReviewDialog();
        notifyRefreshDetail();
      } catch (error) {
        ElMessage.error(error?.message || '审核操作失败');
      } finally {
        reviewSubmitting.value = false;
      }
    };

    // ── 服务跟踪方法 ──

    // 步骤状态辅助
    const stepStatusMap = {
      0: {
        text: '待处理',
        class: 'bg-slate-100 text-slate-600',
        dot: 'bg-slate-400',
        border: 'border-slate-200',
        headerBg: 'bg-white'
      },
      1: {
        text: '进行中',
        class: 'bg-blue-100 text-blue-700',
        dot: 'bg-blue-500',
        border: 'border-blue-300',
        headerBg: 'bg-blue-50'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700',
        dot: 'bg-green-500',
        border: 'border-green-300',
        headerBg: 'bg-green-50'
      }
    };
    const stepStatusText = status => stepStatusMap[status]?.text || '未知';
    const stepStatusBadgeClass = status => stepStatusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const stepDotClass = status => stepStatusMap[status]?.dot || 'bg-slate-400';
    const stepBorderClass = status => stepStatusMap[status]?.border || 'border-slate-200';
    const stepHeaderBgClass = status => stepStatusMap[status]?.headerBg || 'bg-white';
    const stepDialogTitle = computed(() => isEditingStep.value ? '编辑步骤' : '添加步骤');

    // 日期格式转换：yyyy-MM-dd HH:mm:ss → yyyy-MM-ddTHH:mm（用于 datetime-local input）
    const toDatetimeLocal = datetime => {
      if (!datetime) return '';
      return datetime.replace(' ', 'T').substring(0, 16);
    };

    // 日期格式转换：datetime-local → ISO 格式（发送给后端）
    const toApiDatetime = datetimeLocal => {
      if (!datetimeLocal) return null;
      return datetimeLocal + ':00';
    };

    // 加载跟踪数据
    const loadTrackingData = async () => {
      if (!props.orderDetail?.id) return;
      trackingLoading.value = true;
      try {
        const data = await getOrderTracking(props.orderDetail.id);
        steps.value = data.steps || [];
      } catch (error) {
        console.error('加载服务跟踪数据失败:', error);
      } finally {
        trackingLoading.value = false;
      }
    };

    // 切换步骤展开/收起
    const toggleStepExpand = stepId => {
      const newSet = new Set(expandedStepIds.value);
      if (newSet.has(stepId)) {
        newSet.delete(stepId);
      } else {
        newSet.add(stepId);
      }
      expandedStepIds.value = newSet;
    };

    // 添加步骤
    const openAddStepDialog = () => {
      isEditingStep.value = false;
      stepForm.id = null;
      stepForm.name = '';
      stepForm.content = '';
      stepForm.status = 0;
      stepForm.enableReminder = false;
      stepForm.nextRemindAt = '';
      stepForm.remindUserIds = [];
      stepDialogVisible.value = true;
    };

    // 编辑步骤
    const openEditStepDialog = step => {
      isEditingStep.value = true;
      stepForm.id = step.id;
      stepForm.name = step.name || '';
      stepForm.content = step.content || '';
      stepForm.status = step.status;
      stepForm.enableReminder = !!step.nextRemindAt;
      stepForm.nextRemindAt = toDatetimeLocal(step.nextRemindAt);
      stepForm.remindUserIds = [];
      stepDialogVisible.value = true;
    };
    const closeStepDialog = () => {
      stepDialogVisible.value = false;
    };

    // 提交步骤（新增/编辑）
    const handleSubmitStep = async () => {
      if (!stepForm.name) {
        ElMessage.warning('请输入步骤名称');
        return;
      }
      if (!stepForm.content) {
        ElMessage.warning('请输入步骤内容');
        return;
      }
      stepSubmitting.value = true;
      try {
        const remindAt = stepForm.enableReminder ? toApiDatetime(stepForm.nextRemindAt) : null;
        const remindIds = stepForm.enableReminder && stepForm.remindUserIds.length > 0 ? stepForm.remindUserIds : undefined;
        if (isEditingStep.value) {
          await updateServiceStep({
            id: stepForm.id,
            name: stepForm.name || undefined,
            content: stepForm.content || undefined,
            status: stepForm.status,
            nextRemindAt: remindAt,
            remindUserIds: remindIds
          });
          ElMessage.success('步骤更新成功');
        } else {
          await createServiceStep({
            orderId: props.orderDetail.id,
            name: stepForm.name,
            content: stepForm.content,
            nextRemindAt: remindAt,
            remindUserIds: remindIds
          });
          ElMessage.success('步骤添加成功');
        }
        closeStepDialog();
        await loadTrackingData();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      } finally {
        stepSubmitting.value = false;
      }
    };

    // 删除步骤
    const handleDeleteStep = async stepId => {
      try {
        await ElMessageBox.confirm('确认删除该步骤？步骤下的批注和提醒也将一并删除。', '删除确认', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        });
      } catch {
        return;
      }
      try {
        await deleteServiceStep(stepId);
        ElMessage.success('步骤已删除');
        await loadTrackingData();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      }
    };

    // 更新步骤状态
    const handleStepStatusChange = async (stepId, status) => {
      try {
        await updateStepStatus({
          id: stepId,
          status
        });
        ElMessage.success('状态已更新');
        await loadTrackingData();
      } catch (error) {
        ElMessage.error(error.message || '状态更新失败');
      }
    };

    // 添加步骤批注
    const openAddStepAnnotationDialog = stepId => {
      annotationTargetStepId.value = stepId;
      annotationForm.content = '';
      annotationForm.enableReminder = false;
      annotationForm.nextRemindAt = '';
      annotationForm.remindUserIds = [];
      annotationDialogVisible.value = true;
    };
    const closeAnnotationDialog = () => {
      annotationDialogVisible.value = false;
    };

    // 提交批注
    const handleSubmitAnnotation = async () => {
      if (!annotationForm.content) {
        ElMessage.warning('请输入批注内容');
        return;
      }
      annotationSubmitting.value = true;
      try {
        const bizType = annotationTargetStepId.value ? 'ORDER_STEP' : 'ORDER';
        const bizId = annotationTargetStepId.value || props.orderDetail.id;
        await createOrderAnnotation({
          bizType,
          bizId,
          content: annotationForm.content,
          nextRemindAt: annotationForm.enableReminder ? toApiDatetime(annotationForm.nextRemindAt) : null,
          remindUserIds: annotationForm.remindUserIds.length > 0 ? annotationForm.remindUserIds : undefined
        });
        ElMessage.success('批注已添加');
        closeAnnotationDialog();
        await loadTrackingData();
      } catch (error) {
        ElMessage.error(error.message || '添加批注失败');
      } finally {
        annotationSubmitting.value = false;
      }
    };

    // 监听订单详情变化，加载跟踪数据
    watch(() => props.orderDetail?.id, newId => {
      if (newId) {
        loadTrackingData();
      }
    }, {
      immediate: true
    });
    const statusMap = {
      '-1': {
        text: '待审批',
        class: 'bg-amber-100 text-amber-700'
      },
      0: {
        text: '待确认',
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: '执行中',
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: '已取消',
        class: 'bg-red-100 text-red-700'
      },
      4: {
        text: '已驳回',
        class: 'bg-orange-100 text-orange-700'
      }
    };
    const billingStatusMap = {
      0: {
        text: '待收',
        class: 'bg-amber-100 text-amber-700'
      },
      1: {
        text: '已收',
        class: 'bg-green-100 text-green-700'
      },
      2: {
        text: '部分收',
        class: 'bg-blue-100 text-blue-700'
      },
      3: {
        text: '已核销',
        class: 'bg-purple-100 text-purple-700'
      }
    };
    const taskStatusMap = {
      0: {
        text: '待开始',
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: '进行中',
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: '已暂停',
        class: 'bg-amber-100 text-amber-700'
      }
    };
    const getStatusClass = status => statusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getStatusText = status => statusMap[status]?.text || '未知';
    const hasPendingApproval = order => order?.pendingApprovalInstanceId != null;
    const getBillingStatusClass = status => billingStatusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getBillingStatusText = status => billingStatusMap[status]?.text || '未知';

    // ===== 退款 =====
    // 退款展示态独立于既有 billingStatusMap，由 by-billing 接口返回的派生 refundStatus 渲染
    const billingRefundMap = ref({});
    const refundStatusTextMap = {
      REFUNDING: '退款中',
      PARTIAL_REFUNDED: '部分退款',
      FULLY_REFUNDED: '已退完'
    };
    const refundStatusText = billing => {
      const view = billingRefundMap.value[billing?.id];
      return view ? refundStatusTextMap[view.refundStatus] || '' : '';
    };
    const loadBillingRefundViews = async billings => {
      for (const billing of billings || []) {
        // 预取条件：已收过款的账单（paidAmount>0）或已作废账单（status=3，退满后 paid=0 但需展示"已退完"角标）
        if (Number(billing.paidAmount) > 0 || billing.status === 3) {
          try {
            billingRefundMap.value[billing.id] = await getBillingRefundView(billing.id);
          } catch (error) {
            // 退款展示态加载失败不阻断账单展示
          }
        }
      }
    };
    watch(() => props.orderDetail?.billings, billings => {
      loadBillingRefundViews(billings);
    }, {
      immediate: true
    });
    const showRefundModal = ref(false);
    const refundBilling = ref(null);
    const handleRefund = billing => {
      refundBilling.value = billing;
      showRefundModal.value = true;
    };
    const handleRefundSuccess = () => {
      showRefundModal.value = false;
      loadBillingRefundViews([refundBilling.value]);
    };
    const getTaskStatusClass = status => taskStatusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getTaskStatusText = status => taskStatusMap[status]?.text || '未知';
    const getProgressBarClass = status => {
      switch (status) {
        case 0:
          return 'bg-slate-400';
        case 1:
          return 'bg-gradient-to-r from-blue-400 to-blue-600';
        case 2:
          return 'bg-gradient-to-r from-green-400 to-green-600';
        case 3:
          return 'bg-amber-400';
        default:
          return 'bg-slate-400';
      }
    };
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "4xl",
        scrollable: false,
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "订单详情", -1)), _createElementVNode("p", _hoisted_2, _toDisplayString(__props.orderDetail?.orderNo), 1)]), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge text-sm', getStatusClass(__props.orderDetail?.status)])
        }, _toDisplayString(getStatusText(__props.orderDetail?.status)), 3), hasPendingApproval(__props.orderDetail) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-purple",
          title: "查看审批详情",
          "aria-label": "查看审批详情",
          onClick: _cache[0] || (_cache[0] = $event => emit('approval-detail', __props.orderDetail))
        }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[44] || (_cache[44] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800 mb-3"
        }, "订单信息", -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "产品名称", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(__props.orderDetail?.productNameSnapshot || '-'), 1)]), _createElementVNode("div", _hoisted_10, [_cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "产品编码", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(__props.orderDetail?.productCodeSnapshot || '-'), 1)]), _createElementVNode("div", _hoisted_12, [_cache[39] || (_cache[39] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "订单金额", -1)), _createElementVNode("div", _hoisted_13, "¥" + _toDisplayString(__props.orderDetail?.amount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_14, [_cache[40] || (_cache[40] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "创建时间", -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$formatDateTime(__props.orderDetail?.createTime)), 1)]), _createElementVNode("div", _hoisted_16, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "服务开始", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(__props.orderDetail?.serviceStart || '-'), 1)]), _createElementVNode("div", _hoisted_18, [_cache[42] || (_cache[42] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "服务结束", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(__props.orderDetail?.serviceEnd || '-'), 1)]), _createElementVNode("div", _hoisted_20, [_cache[43] || (_cache[43] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-1.5"
        }, "备注", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(__props.orderDetail?.remark || '-'), 1)])])]), _createElementVNode("div", _hoisted_22, [_cache[56] || (_cache[56] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800 mb-3"
        }, "相关人员", -1)), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_cache[47] || (_cache[47] = _createElementVNode("div", {
          class: "flex items-center gap-2 mb-3"
        }, [_createElementVNode("div", {
          class: "w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        })])]), _createElementVNode("span", {
          class: "text-xs font-medium text-blue-600"
        }, "客户信息")], -1)), __props.orderDetail?.customer ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(__props.orderDetail.customer.name), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(__props.orderDetail.customer.statusName || '未知'), 1)]), _createElementVNode("div", _hoisted_29, [_cache[45] || (_cache[45] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.customer.phone || '-'), 1)]), __props.orderDetail.customer.address ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[46] || (_cache[46] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5 mt-0.5 shrink-0",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.customer.address) + _toDisplayString(__props.orderDetail.customer.detailAddress ? ' ' + __props.orderDetail.customer.detailAddress : ''), 1)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_31, "暂无客户信息"))]), _createElementVNode("div", _hoisted_32, [_cache[50] || (_cache[50] = _createElementVNode("div", {
          class: "flex items-center gap-2 mb-3"
        }, [_createElementVNode("div", {
          class: "w-8 h-8 bg-green-500 rounded-full flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        })])]), _createElementVNode("span", {
          class: "text-xs font-medium text-green-600"
        }, "规划师")], -1)), __props.orderDetail?.createUser ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [__props.orderDetail.createUser.avatarUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.orderDetail.createUser.avatarUrl,
          class: "w-8 h-8 rounded-full object-cover",
          alt: ""
        }, null, 8, _hoisted_35)) : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(__props.orderDetail.createUser.displayName?.charAt(0)), 1)), _createElementVNode("span", _hoisted_37, _toDisplayString(__props.orderDetail.createUser.displayName), 1)]), _createElementVNode("div", _hoisted_38, [_cache[48] || (_cache[48] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.createUser.phone || '-'), 1)]), __props.orderDetail.createUser.email ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[49] || (_cache[49] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.createUser.email), 1)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_40, "暂无规划师信息"))]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_cache[53] || (_cache[53] = _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("div", {
          class: "w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        })])]), _createElementVNode("span", {
          class: "text-xs font-medium text-purple-600"
        }, "执行人")], -1)), canChangeExecutor.value ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          visible: showExecutorPopover.value,
          placement: "bottom-end",
          width: 280
        }, {
          reference: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: openExecutorPopover,
            class: "p-1 text-purple-400 hover:text-purple-600 hover:bg-purple-100 rounded transition-colors",
            title: "更换执行人"
          }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          })], -1)]))])), [[_directive_permission, 'order:executor:change']])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_cache[52] || (_cache[52] = _createElementVNode("div", {
            class: "text-sm font-medium text-slate-700"
          }, "更换执行人", -1)), _createVNode(UserSelector, {
            modelValue: newExecutorId.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => newExecutorId.value = $event),
            placeholder: "搜索并选择执行人",
            class: "w-full",
            "exclude-ids": __props.orderDetail?.executorId ? [__props.orderDetail.executorId] : []
          }, null, 8, ["modelValue", "exclude-ids"]), _createElementVNode("div", _hoisted_44, [_createElementVNode("button", {
            onClick: closeExecutorPopover,
            class: "px-3 py-1.5 text-sm bg-slate-100 text-slate-600 rounded-lg hover:bg-slate-200"
          }, "取消"), _createElementVNode("button", {
            disabled: executorSubmitting.value || !newExecutorId.value,
            onClick: handleChangeExecutor,
            class: "px-3 py-1.5 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
          }, "确认更换", 8, _hoisted_45)])])]),
          _: 1
        }, 8, ["visible"])) : _createCommentVNode("", true)]), __props.orderDetail?.executor ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [__props.orderDetail.executor.avatarUrl ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.orderDetail.executor.avatarUrl,
          class: "w-8 h-8 rounded-full object-cover",
          alt: ""
        }, null, 8, _hoisted_48)) : (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(__props.orderDetail.executor.displayName?.charAt(0)), 1)), _createElementVNode("span", _hoisted_50, _toDisplayString(__props.orderDetail.executor.displayName), 1)]), _createElementVNode("div", _hoisted_51, [_cache[54] || (_cache[54] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.executor.phone || '-'), 1)]), __props.orderDetail.executor.email ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_cache[55] || (_cache[55] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        })], -1)), _createElementVNode("span", null, _toDisplayString(__props.orderDetail.executor.email), 1)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_53, "暂无执行人信息"))])])]), __props.orderDetail?.serviceScopeSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_cache[57] || (_cache[57] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "适用对象/范围", -1)), _createElementVNode("div", _hoisted_55, _toDisplayString(__props.orderDetail.serviceScopeSnapshot), 1)])) : _createCommentVNode("", true), __props.orderDetail?.deliverablesSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_cache[58] || (_cache[58] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "交付物", -1)), _createElementVNode("div", _hoisted_57, _toDisplayString(__props.orderDetail.deliverablesSnapshot), 1)])) : _createCommentVNode("", true), __props.orderDetail?.noticesSnapshot ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_cache[59] || (_cache[59] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "注意事项", -1)), _createElementVNode("div", _hoisted_59, _toDisplayString(__props.orderDetail.noticesSnapshot), 1)])) : _createCommentVNode("", true), materialList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_cache[60] || (_cache[60] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800"
        }, "订单资料", -1)), _createElementVNode("span", _hoisted_62, _toDisplayString(materialList.value.length), 1)]), _createElementVNode("div", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialList.value, material => {
          return _openBlock(), _createElementBlock("div", {
            key: material.id,
            class: _normalizeClass(['flex items-center gap-4 p-3 rounded-lg border transition-all duration-150', material.needReview ? 'bg-amber-50/50 border-amber-200' : material.isBound ? 'bg-green-50/50 border-green-200' : 'bg-slate-50/50 border-slate-200', 'hover:shadow-sm'])
          }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", {
            class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center", material.needReview ? 'bg-amber-100' : material.isBound ? 'bg-green-100' : 'bg-slate-100'])
          }, [material.needReview ? (_openBlock(), _createElementBlock("svg", _hoisted_65, [...(_cache[61] || (_cache[61] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          }, null, -1)]))])) : material.isBound ? (_openBlock(), _createElementBlock("svg", _hoisted_66, [...(_cache[62] || (_cache[62] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_67, [...(_cache[63] || (_cache[63] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101"
          }, null, -1)]))]))], 2)]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("h5", _hoisted_70, _toDisplayString(material.materialName || material.name || material.definitionName || material.definitionCode), 1), _createElementVNode("span", _hoisted_71, _toDisplayString(material.definitionCode || '-'), 1), material.isRequired === true || material.isRequired === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_72, "必填")) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(['shrink-0 text-xs px-1.5 py-0.5 rounded-full font-medium', material.bindingStatusClass])
          }, _toDisplayString(material.bindingStatusText), 3)]), _createElementVNode("div", _hoisted_73, [_createElementVNode("span", null, "绑定来源: " + _toDisplayString(material.bindingSourceText), 1), _createElementVNode("span", null, "当前绑定: " + _toDisplayString(material.currentMaterialName || '-'), 1), material.submitTime ? (_openBlock(), _createElementBlock("span", _hoisted_74, "提交: " + _toDisplayString(_ctx.$formatDateTime(material.submitTime)), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(material.visibilityText), 1)]), material.reviewRemark ? (_openBlock(), _createElementBlock("div", _hoisted_75, " 备注: " + _toDisplayString(material.reviewRemark), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_76, [material.currentUserMaterialId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => openMaterialDetailDialog(material),
            class: "p-1.5 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded transition-colors cursor-pointer",
            title: "查看资料"
          }, [...(_cache[64] || (_cache[64] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_77)) : _createCommentVNode("", true), _createElementVNode("button", {
            onClick: $event => openBindingDialog(material),
            class: "p-1.5 text-primary-600 hover:text-primary-700 hover:bg-primary-50 rounded transition-colors cursor-pointer",
            title: material.isBound ? '更换绑定' : '绑定资料'
          }, [...(_cache[65] || (_cache[65] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          })], -1)]))], 8, _hoisted_78), material.isBound ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => openUnbindDialog(material),
            class: "p-1.5 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded transition-colors cursor-pointer",
            title: "解绑"
          }, [...(_cache[66] || (_cache[66] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          })], -1)]))], 8, _hoisted_79)) : _createCommentVNode("", true), material.needReview ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("button", {
            onClick: $event => openReviewDialog(material, true),
            class: "p-1.5 text-green-600 hover:text-green-700 hover:bg-green-50 rounded transition-colors cursor-pointer",
            title: "通过"
          }, [...(_cache[67] || (_cache[67] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_80), _createElementVNode("button", {
            onClick: $event => openReviewDialog(material, false),
            class: "p-1.5 text-red-600 hover:text-red-700 hover:bg-red-50 rounded transition-colors cursor-pointer",
            title: "驳回"
          }, [...(_cache[68] || (_cache[68] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_81)], 64)) : _createCommentVNode("", true)])], 2);
        }), 128))])])) : _createCommentVNode("", true), __props.orderDetail?.billings && __props.orderDetail.billings.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_cache[78] || (_cache[78] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800 mb-3"
        }, "账单明细", -1)), _createElementVNode("div", _hoisted_83, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderDetail.billings, billing => {
          return _openBlock(), _createElementBlock("div", {
            key: billing.id,
            class: "bg-gradient-to-br from-white to-slate-50 rounded-xl border border-slate-200/60 p-4 hover:shadow-md hover:border-slate-300/80 transition-all duration-200 group"
          }, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("span", {
            class: _normalizeClass(["px-2 py-0.5 rounded text-xs font-medium", getBillingStatusClass(billing.status)])
          }, _toDisplayString(getBillingStatusText(billing.status)), 3), refundStatusText(billing) ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(refundStatusText(billing)), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_87, [_createTextVNode(_toDisplayString(billing.billingType === 'ONCE' ? '一次性' : '周期性') + " ", 1), billing.periodType ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(" · " + _toDisplayString({
            MONTH: '月',
            QUARTER: '季',
            YEAR: '年'
          }[billing.periodType]), 1)], 64)) : _createCommentVNode("", true), billing.periodIndex ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(" · 第" + _toDisplayString(billing.periodIndex) + "期 ", 1)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_88, [_cache[69] || (_cache[69] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-0.5"
          }, "应收金额", -1)), _createElementVNode("div", _hoisted_89, "¥" + _toDisplayString(billing.amount?.toLocaleString()), 1)])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_cache[70] || (_cache[70] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "回款进度", -1)), _createElementVNode("span", _hoisted_92, _toDisplayString(billing.amount > 0 ? (billing.paidAmount / billing.amount * 100).toFixed(0) : 0) + "% ", 1)]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", {
            class: "h-full bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full transition-all duration-500",
            style: _normalizeStyle({
              width: billing.amount > 0 ? `${billing.paidAmount / billing.amount * 100}%` : '0%'
            })
          }, null, 4)]), _createElementVNode("div", _hoisted_94, [_createElementVNode("span", null, "已收 ¥" + _toDisplayString(billing.paidAmount?.toLocaleString() || '0'), 1), _createElementVNode("span", null, "待收 ¥" + _toDisplayString((billing.amount - billing.paidAmount).toLocaleString()), 1)])]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_cache[71] || (_cache[71] = _createElementVNode("div", {
            class: "text-slate-400 mb-0.5"
          }, "应收日期", -1)), _createElementVNode("div", _hoisted_97, _toDisplayString(billing.dueDate || '-'), 1)]), _createElementVNode("div", _hoisted_98, [_cache[72] || (_cache[72] = _createElementVNode("div", {
            class: "text-slate-400 mb-0.5"
          }, "收款时间", -1)), _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.$formatDateTime(billing.paidTime) || '-'), 1)])]), _createElementVNode("div", _hoisted_100, [_createElementVNode("span", _hoisted_101, _toDisplayString(billing.payChannel || '-'), 1), _createElementVNode("div", _hoisted_102, [billing.status === 0 || billing.status === 2 || billing.status === '0' || billing.status === '2' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleReceive(billing),
            class: "px-3 py-1.5 text-xs bg-primary-700 hover:bg-primary-800 text-white rounded-lg font-medium transition-colors flex items-center gap-1.5"
          }, [...(_cache[73] || (_cache[73] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
          })], -1), _createTextVNode(" 收款 ", -1)]))], 8, _hoisted_103)), [[_directive_permission, 'billing:receive']]), _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: cmd => handleCashierAction(cmd, billing)
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: "open"
              }, {
                default: _withCtx(() => [...(_cache[75] || (_cache[75] = [_createElementVNode("svg", {
                  class: "w-4 h-4 mr-2",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [_createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                })], -1), _createTextVNode(" 收银台 ", -1)]))]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "copy"
              }, {
                default: _withCtx(() => [...(_cache[76] || (_cache[76] = [_createElementVNode("svg", {
                  class: "w-4 h-4 mr-2",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [_createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                })], -1), _createTextVNode(" 复制链接 ", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("button", {
              disabled: creatingCashierBillingId.value === billing.id,
              class: "px-3 py-1.5 text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium transition-colors disabled:opacity-60 flex items-center gap-1.5"
            }, [...(_cache[74] || (_cache[74] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z"
            })], -1), _createTextVNode(" 收银 ", -1), _createElementVNode("svg", {
              class: "w-3 h-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            })], -1)]))], 8, _hoisted_104)]),
            _: 2
          }, 1032, ["onCommand"])], 64)) : billing.status === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_105, [...(_cache[77] || (_cache[77] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 已支付 ", -1)]))])) : _createCommentVNode("", true), Number(billing.paidAmount) > 0 ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: $event => handleRefund(billing),
            class: "px-3 py-1.5 text-xs bg-rose-50 hover:bg-rose-100 text-rose-600 rounded-lg font-medium transition-colors"
          }, " 退款 ", 8, _hoisted_106)) : _createCommentVNode("", true)])])]);
        }), 128))])])) : _createCommentVNode("", true), __props.orderDetail?.tasks && __props.orderDetail.tasks.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_cache[83] || (_cache[83] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800 mb-3"
        }, "任务列表", -1)), _createElementVNode("div", _hoisted_108, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderDetail.tasks, task => {
          return _openBlock(), _createElementBlock("div", {
            key: task.id,
            class: "relative bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-xl p-4 hover:shadow-md transition-all duration-200"
          }, [_createElementVNode("div", _hoisted_109, [_createElementVNode("span", _hoisted_110, _toDisplayString(task.sort ?? '#'), 1)]), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createElementVNode("h5", _hoisted_114, _toDisplayString(task.name), 1), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded-full text-xs font-medium', getTaskStatusClass(task.status)])
          }, _toDisplayString(task.statusDesc || getTaskStatusText(task.status)), 3)]), task.type ? (_openBlock(), _createElementBlock("p", _hoisted_115, _toDisplayString(task.type), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
            onClick: $event => handleEditTask(task),
            class: "ml-2 p-1.5 text-slate-400 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors",
            title: "编辑任务"
          }, [...(_cache[79] || (_cache[79] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_116)]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_cache[80] || (_cache[80] = _createElementVNode("span", null, "任务进度", -1)), _createElementVNode("span", _hoisted_119, _toDisplayString(task.progress || 0) + "%", 1)]), _createElementVNode("div", _hoisted_120, [_createElementVNode("div", {
            class: _normalizeClass(['h-full rounded-full transition-all duration-300', getProgressBarClass(task.status)]),
            style: _normalizeStyle({
              width: `${task.progress || 0}%`
            })
          }, null, 6)])]), task.assigneeName ? (_openBlock(), _createElementBlock("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, _toDisplayString(task.assigneeName?.charAt(0)), 1), _createElementVNode("span", _hoisted_123, _toDisplayString(task.assigneeName), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_124, [task.startTime ? (_openBlock(), _createElementBlock("div", _hoisted_125, [_cache[81] || (_cache[81] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$formatDateTime(task.startTime)), 1)])) : _createCommentVNode("", true), task.endTime ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_cache[82] || (_cache[82] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$formatDateTime(task.endTime)), 1)])) : _createCommentVNode("", true)]), task.remark ? (_openBlock(), _createElementBlock("div", _hoisted_127, [_createElementVNode("p", _hoisted_128, _toDisplayString(task.remark), 1)])) : _createCommentVNode("", true)]);
        }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_129, [_createElementVNode("div", {
          class: "flex items-center justify-between mb-3"
        }, [_cache[84] || (_cache[84] = _createElementVNode("span", {
          class: "text-sm font-semibold text-slate-800"
        }, "服务步骤", -1)), _createElementVNode("button", {
          onClick: openAddStepDialog,
          class: "px-3 py-1.5 text-xs bg-primary-700 text-white rounded-lg hover:bg-primary-800 transition-colors"
        }, " + 添加步骤 ")]), steps.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_130, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (stepItem, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: stepItem.step.id,
            class: _normalizeClass(["border rounded-lg overflow-hidden", stepBorderClass(stepItem.step.status)])
          }, [_createElementVNode("div", {
            class: _normalizeClass(["flex items-center justify-between px-4 py-3 cursor-pointer select-none", stepHeaderBgClass(stepItem.step.status)]),
            onClick: $event => toggleStepExpand(stepItem.step.id)
          }, [_createElementVNode("div", _hoisted_132, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full", stepDotClass(stepItem.step.status)])
          }, null, 2), _createElementVNode("span", {
            class: _normalizeClass(["font-semibold text-sm", stepItem.step.status === 0 ? 'text-slate-400' : 'text-slate-900'])
          }, "步骤 " + _toDisplayString(index + 1) + " · " + _toDisplayString(stepItem.step.name), 3), _createElementVNode("span", {
            class: _normalizeClass(["px-1.5 py-0.5 rounded text-xs font-medium", stepStatusBadgeClass(stepItem.step.status)])
          }, _toDisplayString(stepStatusText(stepItem.step.status)), 3)]), _createElementVNode("span", _hoisted_133, [_createTextVNode(_toDisplayString(expandedStepIds.value.has(stepItem.step.id) ? '收起' : '展开') + " ", 1), (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["w-3 h-3 transition-transform duration-200", {
              'rotate-180': expandedStepIds.value.has(stepItem.step.id)
            }]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...(_cache[85] || (_cache[85] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          }, null, -1)]))], 2))])], 10, _hoisted_131), _createElementVNode("div", {
            class: _normalizeClass(["px-4 py-3 text-sm border-b border-slate-100", stepItem.step.status === 0 ? 'text-slate-400' : 'text-slate-600'])
          }, _toDisplayString(stepItem.step.content || '暂无描述'), 3), _createElementVNode("div", _hoisted_134, [stepItem.step.nextRemindAt ? (_openBlock(), _createElementBlock("span", _hoisted_135, [_cache[86] || (_cache[86] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" 下次提醒：" + _toDisplayString(stepItem.step.nextRemindAt), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_136, [...(_cache[87] || (_cache[87] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1), _createTextVNode(" 无提醒 ", -1)]))])), _createElementVNode("span", null, "创建人：" + _toDisplayString(stepItem.step.createBy || '-'), 1), _createElementVNode("span", null, _toDisplayString(_unref(formatDateTimeText)(stepItem.step.createTime)), 1)]), expandedStepIds.value.has(stepItem.step.id) ? (_openBlock(), _createElementBlock("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, [_createElementVNode("div", _hoisted_139, [_cache[88] || (_cache[88] = _createElementVNode("div", {
            class: "text-xs text-slate-400 mb-3"
          }, "步骤批注", -1)), _createElementVNode("div", _hoisted_140, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepItem.annotations, ann => {
            return _openBlock(), _createElementBlock("div", {
              key: ann.id,
              class: "flex items-start gap-2.5"
            }, [_createElementVNode("div", {
              class: "w-7 h-7 rounded-full flex items-center justify-center text-white text-xs shrink-0",
              style: _normalizeStyle({
                backgroundColor: getAvatarColor(ann.operatorName)
              })
            }, _toDisplayString(ann.operatorName?.charAt(0) || '?'), 5), _createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, [_createElementVNode("strong", _hoisted_143, _toDisplayString(ann.operatorName), 1), _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.$formatDateTime(ann.createTime)), 1)]), _createElementVNode("div", _hoisted_145, _toDisplayString(ann.content), 1)])]);
          }), 128)), stepItem.annotations.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_146, " 暂无批注 ")) : _createCommentVNode("", true)]), _createElementVNode("button", {
            onClick: $event => openAddStepAnnotationDialog(stepItem.step.id),
            class: "mt-3 text-xs text-primary-600 hover:text-primary-700 px-2 py-1 rounded transition-colors"
          }, " + 添加批注 ", 8, _hoisted_147)])]), _createElementVNode("div", _hoisted_148, [stepItem.step.status === 0 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleStepStatusChange(stepItem.step.id, 1),
            class: "px-3 py-1 text-xs bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition-colors"
          }, "标记进行中", 8, _hoisted_149)) : _createCommentVNode("", true), stepItem.step.status === 1 ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handleStepStatusChange(stepItem.step.id, 2),
            class: "px-3 py-1 text-xs bg-green-50 text-green-600 rounded hover:bg-green-100 transition-colors"
          }, "标记完成", 8, _hoisted_150)) : _createCommentVNode("", true), stepItem.step.status === 2 ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: $event => handleStepStatusChange(stepItem.step.id, 1),
            class: "px-3 py-1 text-xs bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition-colors"
          }, "重新打开", 8, _hoisted_151)) : _createCommentVNode("", true), _createElementVNode("button", {
            onClick: $event => openEditStepDialog(stepItem.step),
            class: "px-3 py-1 text-xs bg-slate-100 text-slate-600 rounded hover:bg-slate-200 transition-colors"
          }, "编辑步骤", 8, _hoisted_152), _createElementVNode("button", {
            onClick: $event => handleDeleteStep(stepItem.step.id),
            class: "px-3 py-1 text-xs bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors"
          }, "删除", 8, _hoisted_153)])])) : _createCommentVNode("", true)], 2);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_154, [_cache[89] || (_cache[89] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "暂无服务步骤", -1)), _createElementVNode("button", {
          onClick: openAddStepDialog,
          class: "mt-2 text-xs text-primary-600 hover:text-primary-700"
        }, " 点击上方按钮添加 ")]))]), _createElementVNode("div", _hoisted_155, [_createElementVNode("div", _hoisted_156, [_createElementVNode("div", _hoisted_157, [_cache[90] || (_cache[90] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-800"
        }, "订单提醒", -1)), _createElementVNode("span", _hoisted_158, _toDisplayString(orderReminderList.value.length), 1)]), _createElementVNode("button", {
          onClick: openAddReminderDialog,
          class: "px-3 py-1.5 text-xs bg-primary-700 text-white rounded-lg hover:bg-primary-800 transition-colors"
        }, " + 添加提醒 ")]), orderReminderList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_159, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderReminderList.value, reminder => {
          return _openBlock(), _createElementBlock("div", {
            key: reminder.id,
            class: "rounded-lg border border-slate-200 bg-white p-3 hover:shadow-sm transition-shadow"
          }, [_createElementVNode("div", _hoisted_160, [_createElementVNode("div", _hoisted_161, [_createElementVNode("div", _hoisted_162, [_createElementVNode("h5", _hoisted_163, _toDisplayString(reminder.title), 1), _createElementVNode("span", {
            class: _normalizeClass(['shrink-0 px-1.5 py-0.5 rounded-full text-xs font-medium', reminderStatusClass(reminder.status)])
          }, _toDisplayString(reminder.statusDesc || reminderStatusText(reminder.status)), 3), reminder.repeatEnabled ? (_openBlock(), _createElementBlock("span", _hoisted_164, " 重复 ")) : _createCommentVNode("", true)]), reminder.content ? (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString(reminder.content), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_166, [_createElementVNode("span", null, "首次提醒: " + _toDisplayString(_ctx.$formatDateTime(reminder.firstSendTime)), 1), _createElementVNode("span", null, _toDisplayString(reminderRepeatText(reminder)), 1), reminder.deadlineTime ? (_openBlock(), _createElementBlock("span", _hoisted_167, "截止: " + _toDisplayString(_ctx.$formatDateTime(reminder.deadlineTime)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_168, [_cache[91] || (_cache[91] = _createElementVNode("span", {
            class: "text-xs text-slate-400 mr-1"
          }, "接收人", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminder.receivers || [], receiver => {
            return _openBlock(), _createElementBlock("span", {
              key: receiver.userId,
              class: "px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 text-xs"
            }, _toDisplayString(receiver.userName || `用户${receiver.userId}`), 1);
          }), 128)), !reminder.receivers?.length ? (_openBlock(), _createElementBlock("span", _hoisted_169, "未配置")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_170, [_createElementVNode("button", {
            onClick: $event => openEditReminderDialog(reminder),
            class: "px-2 py-1 text-xs bg-slate-100 text-slate-600 rounded hover:bg-slate-200 transition-colors"
          }, "编辑", 8, _hoisted_171), reminder.status === 'ENABLED' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleToggleReminder(reminder),
            class: "px-2 py-1 text-xs bg-amber-50 text-amber-700 rounded hover:bg-amber-100 transition-colors"
          }, "停用", 8, _hoisted_172)) : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handleToggleReminder(reminder),
            class: "px-2 py-1 text-xs bg-green-50 text-green-700 rounded hover:bg-green-100 transition-colors"
          }, "启用", 8, _hoisted_173)), _createElementVNode("button", {
            onClick: $event => handleDeleteReminder(reminder),
            class: "px-2 py-1 text-xs bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors"
          }, "删除", 8, _hoisted_174)])])]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_175, [_cache[92] || (_cache[92] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "暂无订单提醒", -1)), _createElementVNode("button", {
          onClick: openAddReminderDialog,
          class: "mt-2 text-xs text-primary-600 hover:text-primary-700"
        }, " 添加一个提醒 ")]))])])]), _createElementVNode("div", _hoisted_176, [_createElementVNode("div", _hoisted_177, [_createElementVNode("div", _hoisted_178, [__props.orderDetail?.status !== 2 && __props.orderDetail?.status !== 3 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleEdit,
          class: "h-10 px-5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 inline-flex items-center justify-center gap-2 transition-colors"
        }, [...(_cache[93] || (_cache[93] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1), _createElementVNode("span", null, "编辑", -1)]))])), [[_directive_permission, 'order:edit']]) : _createCommentVNode("", true), _createElementVNode("button", {
          onClick: handleClose,
          class: "h-10 px-5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 inline-flex items-center justify-center"
        }, "关闭")])])])]),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_el_dialog, {
        modelValue: bindingDialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => bindingDialogVisible.value = $event),
        title: "选择资料",
        width: "960px",
        "destroy-on-close": "",
        onClose: closeBindingDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_192, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeBindingDialog
        }, "取消"), _createElementVNode("button", {
          disabled: bindingSubmitting.value || !selectedCandidateId.value,
          class: "px-4 py-2 text-sm bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50",
          onClick: handleConfirmBinding
        }, _toDisplayString(bindingSubmitting.value ? '提交中...' : '确认绑定'), 9, _hoisted_193)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_179, [_createElementVNode("div", _hoisted_180, [_createElementVNode("div", null, "订单材料：" + _toDisplayString(bindingTargetMaterial.value?.materialName || bindingTargetMaterial.value?.definitionName || '-'), 1), _createElementVNode("div", _hoisted_181, "资料类型：" + _toDisplayString(bindingTargetMaterial.value?.definitionCode || '-'), 1), _cache[94] || (_cache[94] = _createElementVNode("div", {
          class: "mt-1 text-xs text-slate-500"
        }, "仅展示当前订单材料类型匹配的客户资料实例", -1))]), _createElementVNode("div", _hoisted_182, [_createVNode(_component_el_input, {
          modelValue: candidateKeyword.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => candidateKeyword.value = $event),
          clearable: "",
          placeholder: "按资料名称或类型搜索"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: candidateVisibilityFilter.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => candidateVisibilityFilter.value = $event),
          clearable: "",
          placeholder: "客户可见性",
          class: "w-45"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }), _createVNode(_component_el_option, {
            label: "对客户可见",
            value: "visible"
          }), _createVNode(_component_el_option, {
            label: "对客户隐藏",
            value: "hidden"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_183, [_createElementVNode("table", _hoisted_184, [_cache[97] || (_cache[97] = _createElementVNode("thead", {
          class: "bg-slate-50 text-slate-500"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "选择"), _createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "资料名称"), _createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "资料类型"), _createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "最后更新时间"), _createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "客户可见性"), _createElementVNode("th", {
          class: "px-4 py-3 text-left font-medium"
        }, "绑定状态")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMaterialCandidates.value, candidate => {
          return _openBlock(), _createElementBlock("tr", {
            key: candidate.id,
            class: "border-t border-slate-100"
          }, [_createElementVNode("td", _hoisted_185, [_createVNode(_component_el_radio, {
            modelValue: selectedCandidateId.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedCandidateId.value = $event),
            label: candidate.id
          }, {
            default: _withCtx(() => [...(_cache[95] || (_cache[95] = [_createElementVNode("span", null, null, -1)]))]),
            _: 1
          }, 8, ["modelValue", "label"])]), _createElementVNode("td", _hoisted_186, _toDisplayString(candidate.name || '-'), 1), _createElementVNode("td", _hoisted_187, _toDisplayString(candidate.definitionName || candidate.definitionCode || '-'), 1), _createElementVNode("td", _hoisted_188, _toDisplayString(_ctx.$formatDateTime(candidate.updateTime || candidate.createTime)), 1), _createElementVNode("td", _hoisted_189, [_createElementVNode("span", {
            class: _normalizeClass(['rounded-full px-2 py-0.5 text-xs font-medium', candidate.visibleToCustomer ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'])
          }, _toDisplayString(getCandidateVisibilityText(candidate.visibleToCustomer)), 3)]), _createElementVNode("td", _hoisted_190, _toDisplayString(candidate.isCurrentBinding ? '当前已绑定' : '-'), 1)]);
        }), 128)), !bindingDialogLoading.value && filteredMaterialCandidates.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_191, [...(_cache[96] || (_cache[96] = [_createElementVNode("td", {
          colspan: "6",
          class: "px-4 py-8 text-center text-slate-500"
        }, "暂无可选资料", -1)]))])) : _createCommentVNode("", true)])])])), [[_directive_loading, bindingDialogLoading.value]])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: unbindDialogVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => unbindDialogVisible.value = $event),
        title: "解绑资料",
        width: "520px",
        "destroy-on-close": "",
        onClose: closeUnbindDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_196, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeUnbindDialog
        }, "取消"), _createElementVNode("button", {
          disabled: unbindSubmitting.value,
          class: "px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50",
          onClick: handleConfirmUnbind
        }, _toDisplayString(unbindSubmitting.value ? '解绑中...' : '确认解绑'), 9, _hoisted_197)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_194, [_createElementVNode("div", _hoisted_195, " 确认解绑“" + _toDisplayString(unbindTargetMaterial.value?.materialName || unbindTargetMaterial.value?.definitionName || '-') + "”当前绑定的资料吗？ ", 1), _createVNode(_component_el_input, {
          modelValue: unbindReason.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => unbindReason.value = $event),
          type: "textarea",
          rows: 4,
          maxlength: "200",
          "show-word-limit": "",
          placeholder: "请输入解绑原因，便于后续追溯"
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: reviewDialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => reviewDialogVisible.value = $event),
        title: reviewForm.approved ? '审核通过' : '驳回绑定',
        width: "520px",
        "destroy-on-close": "",
        onClose: closeReviewDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_200, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeReviewDialog
        }, "取消"), _createElementVNode("button", {
          disabled: reviewSubmitting.value,
          class: _normalizeClass(['px-4 py-2 text-sm text-white rounded-lg disabled:opacity-50', reviewForm.approved ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700']),
          onClick: handleSubmitReview
        }, _toDisplayString(reviewSubmitting.value ? '提交中...' : reviewForm.approved ? '确认通过' : '确认驳回'), 11, _hoisted_201)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_198, [_createElementVNode("div", _hoisted_199, _toDisplayString(reviewTargetMaterial.value?.materialName || reviewTargetMaterial.value?.definitionName || '-') + " 当前由客户在 APP 侧提交绑定。 ", 1), _createVNode(_component_el_input, {
          modelValue: reviewForm.reviewRemark,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => reviewForm.reviewRemark = $event),
          type: "textarea",
          rows: 4,
          maxlength: "200",
          "show-word-limit": "",
          placeholder: reviewForm.approved ? '可选填写审核备注' : '请输入驳回原因'
        }, null, 8, ["modelValue", "placeholder"])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(OrderMaterialDetailDialog, {
        visible: materialDetailDialogVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => materialDetailDialogVisible.value = $event),
        "user-material-id": selectedMaterialDetailId.value
      }, null, 8, ["visible", "user-material-id"]), _createVNode(_component_el_dialog, {
        modelValue: reminderDialogVisible.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => reminderDialogVisible.value = $event),
        title: reminderDialogTitle.value,
        width: "680px",
        "destroy-on-close": "",
        onClose: closeReminderDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_212, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeReminderDialog
        }, "取消"), _createElementVNode("button", {
          disabled: reminderSubmitting.value,
          class: "px-4 py-2 text-sm bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50",
          onClick: handleSubmitReminder
        }, _toDisplayString(reminderSubmitting.value ? '提交中...' : '确认'), 9, _hoisted_213)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_202, [_createElementVNode("div", null, [_cache[98] || (_cache[98] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode("提醒标题 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.title,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => reminderForm.title = $event),
          placeholder: "请输入提醒标题",
          maxlength: "100",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[99] || (_cache[99] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "提醒内容", -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.content,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => reminderForm.content = $event),
          type: "textarea",
          rows: 3,
          placeholder: "请输入提醒内容",
          maxlength: "500",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_203, [_createElementVNode("div", null, [_cache[100] || (_cache[100] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode("首次提醒时间 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.firstSendTime,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => reminderForm.firstSendTime = $event),
          type: "datetime-local"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[101] || (_cache[101] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "截止时间", -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.deadlineTime,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => reminderForm.deadlineTime = $event),
          type: "datetime-local"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_204, [_createElementVNode("label", _hoisted_205, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => reminderForm.repeatEnabled = $event),
          type: "checkbox",
          class: "w-4 h-4 rounded"
        }, null, 512), [[_vModelCheckbox, reminderForm.repeatEnabled]]), _cache[102] || (_cache[102] = _createElementVNode("span", null, "重复提醒", -1))]), reminderForm.repeatEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_206, [_createElementVNode("div", null, [_cache[103] || (_cache[103] = _createElementVNode("label", {
          class: "block text-xs text-slate-500 mb-1"
        }, "重复间隔（分钟）", -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.repeatIntervalMinutes,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => reminderForm.repeatIntervalMinutes = $event),
          modelModifiers: {
            number: true
          },
          type: "number",
          min: "1"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[104] || (_cache[104] = _createElementVNode("label", {
          class: "block text-xs text-slate-500 mb-1"
        }, "最大提醒次数", -1)), _createVNode(_component_el_input, {
          modelValue: reminderForm.maxReminderCount,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => reminderForm.maxReminderCount = $event),
          modelModifiers: {
            number: true
          },
          type: "number",
          min: "1"
        }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_207, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => reminderForm.autoCloseAtDeadline = $event),
          type: "checkbox",
          class: "w-4 h-4 rounded"
        }, null, 512), [[_vModelCheckbox, reminderForm.autoCloseAtDeadline]]), _cache[105] || (_cache[105] = _createElementVNode("span", null, "到截止时间自动关闭提醒", -1))])]), _createElementVNode("div", null, [_cache[107] || (_cache[107] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode("提醒接收人 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), orderRelatedReminderUsers.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_208, [_cache[106] || (_cache[106] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-2"
        }, "订单关联人员", -1)), _createElementVNode("div", _hoisted_209, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderRelatedReminderUsers.value, user => {
          return _openBlock(), _createElementBlock("button", {
            key: user.id,
            type: "button",
            class: _normalizeClass(['px-3 py-1.5 rounded-full border text-xs transition-colors', isReminderReceiverSelected(user.id) ? 'border-primary-200 bg-primary-50 text-primary-700' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50']),
            onClick: $event => toggleReminderReceiver(user.id)
          }, [_createTextVNode(_toDisplayString(user.displayName || user.username || `用户${user.id}`) + " ", 1), user.roles.length ? (_openBlock(), _createElementBlock("span", _hoisted_211, _toDisplayString(user.roles.join('/')), 1)) : _createCommentVNode("", true)], 10, _hoisted_210);
        }), 128))])])) : _createCommentVNode("", true), _createVNode(UserSelector, {
          modelValue: reminderForm.receiverUserIds,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => reminderForm.receiverUserIds = $event),
          multiple: "",
          placeholder: "搜索并选择其他提醒人员",
          class: "w-full"
        }, null, 8, ["modelValue"])])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: stepDialogVisible.value,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => stepDialogVisible.value = $event),
        title: stepDialogTitle.value,
        width: "520px",
        "destroy-on-close": "",
        onClose: closeStepDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_223, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeStepDialog
        }, "取消"), _createElementVNode("button", {
          disabled: stepSubmitting.value || !stepForm.name || !stepForm.content,
          class: "px-4 py-2 text-sm bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50",
          onClick: handleSubmitStep
        }, _toDisplayString(stepSubmitting.value ? '提交中...' : '确认'), 9, _hoisted_224)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_214, [_createElementVNode("div", null, [_cache[108] || (_cache[108] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode("步骤名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_input, {
          modelValue: stepForm.name,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => stepForm.name = $event),
          placeholder: "请输入步骤名称",
          maxlength: "100",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[109] || (_cache[109] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode("步骤内容 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_input, {
          modelValue: stepForm.content,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => stepForm.content = $event),
          type: "textarea",
          rows: 3,
          placeholder: "请输入步骤内容/描述",
          maxlength: "500",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]), stepForm.id ? (_openBlock(), _createElementBlock("div", _hoisted_215, [_cache[110] || (_cache[110] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "状态", -1)), _createVNode(_component_el_select, {
          modelValue: stepForm.status,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => stepForm.status = $event),
          class: "w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "待处理",
            value: 0
          }), _createVNode(_component_el_option, {
            label: "进行中",
            value: 1
          }), _createVNode(_component_el_option, {
            label: "已完成",
            value: 2
          })]),
          _: 1
        }, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_216, [_createElementVNode("label", _hoisted_217, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => stepForm.enableReminder = $event),
          type: "checkbox",
          class: "w-4 h-4 rounded"
        }, null, 512), [[_vModelCheckbox, stepForm.enableReminder]]), _cache[111] || (_cache[111] = _createElementVNode("span", null, "设置提醒", -1))])]), stepForm.enableReminder ? (_openBlock(), _createElementBlock("div", _hoisted_218, [_createElementVNode("div", null, [_cache[112] || (_cache[112] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "提醒时间", -1)), _createVNode(_component_el_input, {
          modelValue: stepForm.nextRemindAt,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => stepForm.nextRemindAt = $event),
          type: "datetime-local",
          placeholder: "选择提醒时间"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[114] || (_cache[114] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "提醒接收人", -1)), orderRelatedReminderUsers.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_219, [_cache[113] || (_cache[113] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-2"
        }, "订单关联人员", -1)), _createElementVNode("div", _hoisted_220, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderRelatedReminderUsers.value, user => {
          return _openBlock(), _createElementBlock("button", {
            key: user.id,
            type: "button",
            class: _normalizeClass(['px-3 py-1.5 rounded-full border text-xs transition-colors', stepForm.remindUserIds.includes(user.id) ? 'border-primary-200 bg-primary-50 text-primary-700' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50']),
            onClick: $event => toggleStepRemindUser(user.id)
          }, [_createTextVNode(_toDisplayString(user.displayName || user.username || `用户${user.id}`) + " ", 1), user.roles.length ? (_openBlock(), _createElementBlock("span", _hoisted_222, _toDisplayString(user.roles.join('/')), 1)) : _createCommentVNode("", true)], 10, _hoisted_221);
        }), 128))])])) : _createCommentVNode("", true), _createVNode(UserSelector, {
          modelValue: stepForm.remindUserIds,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => stepForm.remindUserIds = $event),
          multiple: "",
          placeholder: "搜索并选择提醒人员",
          class: "w-full"
        }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: annotationDialogVisible.value,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => annotationDialogVisible.value = $event),
        title: "添加批注",
        width: "480px",
        "destroy-on-close": "",
        onClose: closeAnnotationDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_233, [_createElementVNode("button", {
          class: "px-4 py-2 text-sm bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200",
          onClick: closeAnnotationDialog
        }, "取消"), _createElementVNode("button", {
          disabled: annotationSubmitting.value || !annotationForm.content,
          class: "px-4 py-2 text-sm bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50",
          onClick: handleSubmitAnnotation
        }, _toDisplayString(annotationSubmitting.value ? '提交中...' : '提交批注'), 9, _hoisted_234)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_225, [_createElementVNode("div", null, [_cache[115] || (_cache[115] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode("批注内容 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_input, {
          modelValue: annotationForm.content,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => annotationForm.content = $event),
          type: "textarea",
          rows: 4,
          placeholder: "请输入批注内容",
          maxlength: "500",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_226, [_createElementVNode("label", _hoisted_227, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => annotationForm.enableReminder = $event),
          type: "checkbox",
          class: "w-4 h-4 rounded"
        }, null, 512), [[_vModelCheckbox, annotationForm.enableReminder]]), _cache[116] || (_cache[116] = _createElementVNode("span", null, "设置提醒", -1))])]), annotationForm.enableReminder ? (_openBlock(), _createElementBlock("div", _hoisted_228, [_createElementVNode("div", null, [_cache[117] || (_cache[117] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "提醒时间", -1)), _createVNode(_component_el_input, {
          modelValue: annotationForm.nextRemindAt,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => annotationForm.nextRemindAt = $event),
          type: "datetime-local",
          placeholder: "选择提醒时间"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[119] || (_cache[119] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "提醒接收人", -1)), orderRelatedReminderUsers.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_229, [_cache[118] || (_cache[118] = _createElementVNode("div", {
          class: "text-xs text-slate-400 mb-2"
        }, "订单关联人员", -1)), _createElementVNode("div", _hoisted_230, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderRelatedReminderUsers.value, user => {
          return _openBlock(), _createElementBlock("button", {
            key: user.id,
            type: "button",
            class: _normalizeClass(['px-3 py-1.5 rounded-full border text-xs transition-colors', annotationForm.remindUserIds.includes(user.id) ? 'border-primary-200 bg-primary-50 text-primary-700' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50']),
            onClick: $event => toggleAnnotationRemindUser(user.id)
          }, [_createTextVNode(_toDisplayString(user.displayName || user.username || `用户${user.id}`) + " ", 1), user.roles.length ? (_openBlock(), _createElementBlock("span", _hoisted_232, _toDisplayString(user.roles.join('/')), 1)) : _createCommentVNode("", true)], 10, _hoisted_231);
        }), 128))])])) : _createCommentVNode("", true), _createVNode(UserSelector, {
          modelValue: annotationForm.remindUserIds,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => annotationForm.remindUserIds = $event),
          multiple: "",
          placeholder: "搜索并选择提醒人员",
          class: "w-full"
        }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(RefundApplyModal, {
        visible: showRefundModal.value,
        billing: refundBilling.value,
        onClose: _cache[33] || (_cache[33] = $event => showRefundModal.value = false),
        onSuccess: handleRefundSuccess
      }, null, 8, ["visible", "billing"])], 64);
    };
  }
};